import React from "react";
import { Button, ButtonSize, ButtonVariant } from "@taskpane/components";
import css from "./WizardFooter.module.scss";

export interface WizardFooterOption {
  label: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  onClick: () => void;
}

export interface WizardFooterProps {
  options: WizardFooterOption[];
}

const WizardFooter: React.FC<WizardFooterProps> = ({ options }) => {
  const attrs = {
    container: {
      className: css.container,
    },
  };

  const renderOptions = () =>
    options.map(({ label, icon: IconComponent, onClick }, index) => {
      const attrs = {
        button: {
          onClick,
          className: css.button,
          size: ButtonSize.XS,
          variant: ButtonVariant.Secondary,
        },
      };

      return (
        <Button {...attrs.button} key={index}>
          {IconComponent ? <IconComponent /> : null}
          <span>{label}</span>
        </Button>
      );
    });

  if (!options.length) {
    return null;
  }

  return <div {...attrs.container}>{renderOptions()}</div>;
};

export default WizardFooter;
